import { FEATURE_FLAGS } from './featureFlags'

export const INNOSCRIPTA_INTERNAL_ORGANIZATION_ID = 1
export const INNOSCRIPTA_CHAMPION_RESPONSIBLE_NAME = 'innoscripta Champion'

export const DEFAULT_REMEMBER_ME = FEATURE_FLAGS.SHOW_REMEMBER_ME ? false : true
